export enum HandleNegativeOnHand {
  CountCorrection = "count-correction",
}
